import React from "react";
import type {MatchComposition, MatchDetail} from '@iziping/common';
import './MatchToolTip.css';
import HeatRegistrationCard from "../shared/HeatRegistrationCard";

interface MatchCardProps {
    match: MatchDetail
}

const MatchTooltip: React.FC<MatchCardProps> = ({match}) => {
    return (
        <div className={'tooltip-container tooltip'}>
            { match.opponents.map((opponent: MatchComposition) => (
            <span
                className={'match-player'}><HeatRegistrationCard registration={opponent.heatRegistration}/></span>
            ))
            }
        </div>)
}

/*
{opponent?.heatRegistration?.players?.[0].lastname} {opponent.heatRegistration?.players?.[0].firstname} {opponent.heatRegistration?.ranking}
 */

export default MatchTooltip;